export const benefits = [
    "ESPAÇO CUSTOMIZÁVEL (url, cores e logo do seu negócio)",
    "DESCONTOS EXCLUSIVOS",
    "MAIORES E MELHORES CASHBACKS DO MERCADO",
    "CURADORIA DIÁRIA DE DESCONTOS",
    "ATENDIMENTO EXCLUSIVO",
    "MAIOR ENGAJAMENTO",
];

export const formBg = "https://static.meucupom.com/media/LP%20-%20Clube%20de%20beneficio/bg%20formulario.png";
export const checkIcon = "https://static.meucupom.com/media/LP%20-%20Clube%20de%20beneficio/2check.svg";
